import {
  GRID_MODE,
  ObservationsBrowserMode,
  ObservationsItemRenderer,
  TABULAR_MODE,
} from '../types'
import { GridView } from './GridView'
import { TabularView } from './TabularView'
import { ViewProps } from './types'

const renderVoid = () => null

/**
 * Return the appropriate view for the given mode
 */
export const getViewComponent = (
  mode: ObservationsBrowserMode
): ((props: ViewProps) => JSX.Element) =>
  ({
    [GRID_MODE]: GridView,
    [TABULAR_MODE]: TabularView,
  }[mode])

/**
 * Return next view mode given the current one
 */
export const getNextMode = (
  mode: ObservationsBrowserMode
): ObservationsBrowserMode =>
  ({ [GRID_MODE]: TABULAR_MODE, [TABULAR_MODE]: GRID_MODE }[mode])

/**
 * Return either the tabular or grid renderer based on `mode`
 */
export const getItemRenderer = (
  mode: ObservationsBrowserMode,
  renderTabularItem?: ObservationsItemRenderer,
  renderGridItem?: ObservationsItemRenderer
): ObservationsItemRenderer => {
  if (mode === TABULAR_MODE && renderTabularItem) return renderTabularItem
  if (mode === GRID_MODE && renderGridItem) return renderGridItem
  return renderVoid // mode not implemented or renderer not provided
}
